<template>
  <div class="_modals">
    <b-modal ref="modalSurvey" id="modal_survey" centered hide-footer title="">
    <div>
      <p class="text-center"><b>Are you satisfied with Andalin service?</b> <br>
      Tell us your opinion about Andalin and get 500 AndalinPoints</p>
    </div>
    <div class="row mt-4">
      <div class="col-md text-center">
        <button
          @click="gotoSurvey" class="button__bluecorporite ml-2">Yes, Lets do it!
        </button>
        <button @click="closemodal()" class="button__redcorporite ml-2">No, Thank You
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>

export default {
  created () {
    this.$eventHub.$on('dialog-survey', this.dialogSurvey)
  },
  beforeDestroy () {
    this.$eventHub.$off('dialog-survey')
  },
  methods: {
    gotoSurvey () {
      window.open('https://forms.gle/ebkGDWmQeVMth9jQ6')
      this.$refs.modalSurvey.hide()
    },
    closemodal () {
      this.$refs.modalSurvey.hide()
    },
    dialogSurvey (data) {
      this.$refs.modalSurvey.show()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/global/modals/Survey.vue